<template>
    <div class="registerBox">
        <div class="back" @click="back">返回首页</div>
        <div class="bg"></div>
        <div class="conter">
            <step :index="setpIndex"></step>
            <account v-if="setpIndex == 1" @resSuccess="resSuccess"></account>
            <information v-else :id="id"></information>
        </div>
    </div>
</template>

<script>
import account from './account'
import information from './information'
import step from './components/step'
export default {
    data() {
        return {
            setpIndex: 1,
            id: null,
        }
    },
    created() {
        if(this.$route.query.setpIndex) this.setpIndex = this.$route.query.setpIndex;
        if(this.$route.query.id) this.id = this.$route.query.id;
    },
    components: {
        account, information, step
    },
    methods: {
        resSuccess(id) {
            this.setpIndex = 2
            this.id = id
        },
        back() {
            this.$router.push('/login')
        }
    }
}
</script>

<style lang="scss" scoped>
.registerBox{
    width: 100vw;
    height: 100vh;
    background: url("./../../../assets/images/login_bg.png") center center / cover no-repeat;
    display: flex;
    .back{
        width: 112px;
        height: 40px;
        line-height: 22px;
        padding: 9px 12px 9px 36px;
        color: rgba(255, 255, 255, 0.85);
        background: url('../../../assets/images/back.png') 12px center / 22px 22px no-repeat rgba($color: #000000, $alpha: 0.3);
        border-radius: 8px;
        position: fixed;
        top: 24px;
        left: 24px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
    }
    .bg{
        flex: 1;
        height: 100%;
        background: url('https://dance-box.oss-cn-shanghai.aliyuncs.com/2021/01/19/1611058247758104.png') center center / 397px 480px no-repeat;
    }
    .conter{
        width: 733px;
        height: 100vh;
        background-color: #141422;
        position: relative;
        overflow-y: auto;
    }
}
</style>
